<template>
	<Row>
		<Col :span="12">
			<Skeleton :paragraph="{ rows: 7 }" :title="false" :loading="loading">
				<VerticalLayout size="small">
					<TypographyText v-for="envvar in status.envvars" :key="envvar.key">{{ envvar.key }}: {{ envvar.value }}</TypographyText>
				</VerticalLayout>
			</Skeleton>
		</Col>
	</Row>
</template>

<script>
import { TypographyText, Row, Col, Skeleton } from 'ant-design-vue';

import VerticalLayout from '@/components/common/VerticalLayout';

export default {
	components: {
		TypographyText, Row, Col, Skeleton,
		VerticalLayout,
	},
	props: ['loading', 'status'],
}
</script>
